/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MiddlewareError,
  ProductPrices,
} from '../models/index';
import {
    MiddlewareErrorFromJSON,
    MiddlewareErrorToJSON,
    ProductPricesFromJSON,
    ProductPricesToJSON,
} from '../models/index';

export interface GetProductPricesRequest {
    productNumber: string;
}

/**
 * 
 */
export class ProductPricesResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getProductPrices without sending the request
     */
    async getProductPricesRequestOpts(requestParameters: GetProductPricesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productNumber'] == null) {
            throw new runtime.RequiredError(
                'productNumber',
                'Required parameter "productNumber" was null or undefined when calling getProductPrices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/product/{productNumber}/product-prices/`;
        urlPath = urlPath.replace(`{${"productNumber"}}`, encodeURIComponent(String(requestParameters['productNumber'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getProductPricesRaw(requestParameters: GetProductPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductPrices>>> {
        const requestOptions = await this.getProductPricesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductPricesFromJSON));
    }

    /**
     */
    async getProductPrices(requestParameters: GetProductPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductPrices>> {
        const response = await this.getProductPricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
